"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.loadTreatmentEpic = void 0;

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _LaboratoryApi = _interopRequireDefault(require("./LaboratoryApi"));

var _LaboratoryActions = require("./LaboratoryActions");

var _LaboratorySelectors = require("./LaboratorySelectors");

var loadTreatmentEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _LaboratoryApi.default.fetchLaboratoryTreatment,
  initiatingActionType: _LaboratoryActions.LaboratoryActionType.FETCH_LABORATORY_TREATMENT,
  requestStatusSelector: _LaboratorySelectors.getFetchTreatmentsStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _LaboratoryActions.loadTreatment
}));
exports.loadTreatmentEpic = loadTreatmentEpic;
var _default = loadTreatmentEpic;
exports.default = _default;